import {FC, useState} from "react";
import {Search} from "@mui/icons-material";
import {Box} from "@mui/material";
import {makeStyles} from "tss-react/mui";

export interface ITableSettings {
	densePadding: boolean
}

export interface IProps {
	value: string,
	onChange: (e: string) => void
}

const useStyles = makeStyles()((theme) => ({
	adminTableSearchInput: {
		"& input": {
			border: "none",
			textAlign: "left",
			width: "200px",
			paddingLeft: "10px",
			background: theme.palette.background.paper,
			color: theme.palette.common.white
		},
		display: "flex",
		justifyContent: "center",
		gap: "10px",
		"& th": {
			fontSize: "11px",
			fontWeight: 700,
			textTransform: "uppercase"
		}
	},
	icon: {
		cursor: "pointer",
		padding: "2px 6px"
	}
}));

export const AdminTableSearchInput: FC<IProps> = ({value, onChange}) => {
	const {classes} = useStyles();
	const [open, setOpen] = useState<boolean>(false);

	const handleOpenSearch = (): void => {
		onChange("")
		setOpen(prev => !prev);
	}

	return (
		<Box className={classes.adminTableSearchInput}>
			<Search onClick={() => handleOpenSearch()} className={classes.icon}/>
			{open && <input
				value={value}
				autoFocus
				onChange={(e) => onChange(e.target.value)}
				type="text"
				id="search"
				name="search"
			/>}
		</Box>
	);
}